import { render, staticRenderFns } from "./ContentPost.vue?vue&type=template&id=35ec8bda&"
import script from "./ContentPost.vue?vue&type=script&lang=js&"
export * from "./ContentPost.vue?vue&type=script&lang=js&"
import style0 from "./ContentPost.vue?vue&type=style&index=0&id=35ec8bda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports